import { useMemo } from 'react';
import { convertToArray } from '../../../../utils/util';
import { FieldWrapper } from '../common';
import ApiaComponent from '../ApiaComponent';
import { TApiaForm } from '../../../../types';
import { sortFieldsCoordinates } from '../utils/executionUtil';

export const ApiaComponentsRenderer = ({
  formId,
  formData,
}: {
  formId: string;
  formData: TApiaForm;
}) => {
  const field = useMemo(() => convertToArray(formData.field), [formData.field]);
  const sortedFields = useMemo(() => sortFieldsCoordinates(field), [field]);

  return (
    <>
      {sortedFields.map((f) => {
        return (
          <FieldWrapper
            key={`field_wrapper_${formId}_${f.id}`}
            id={`wrapper_${formId}`}
            fieldId={`${formId}_${f.id}`}
            x={f.x + 1}
            y={f.y + 1}
            cols={f.cols}
            rows={f.rows}
            fieldType={f.fieldType}
            attName={f.attName}
            name={f.properties.name}
            valueType={f.valueType || f.fieldType}
            formCols={formData.cols}
            field={f}
          >
            <ApiaComponent
              key={`component_${formId}_${f.id}`}
              field={f}
              onGrid={false}
            />
          </FieldWrapper>
        );
      })}
    </>
  );
};

export default ApiaComponentsRenderer;
